import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBillingAccounts } from '../../../../global/ducks/mlps-api';
import { TcsmStates } from '../../../../root/tcsm-model';
import { BillingAccountsState } from './billing-accounts-models';
import { beginBillingAccountRequest, dispatchSetBillingAccount } from './billing-accounts-slice';


export function useBillingAccountState(groupId: number) {
    const dispatch = useDispatch();
    const billingAccountState = useSelector<TcsmStates, BillingAccountsState>(state => state.billingAccountsState);

    useEffect(() => {
        if (groupId && !billingAccountState.billingAccountsLoaded && !billingAccountState.requesting) {
            dispatch(beginBillingAccountRequest());
            dispatch(getBillingAccounts(groupId, dispatchSetBillingAccount(dispatch)));
        }
    }, [groupId]);

    return billingAccountState;
}